.ux-iws-calculator {
    display: block;
}
